import { axiosInstance } from "./api";

/**
 * Get user info by token.
 * @param payload - {idToken: string | null, companyId: string | null}
 * @returns any
 */
export async function apiGetUser(
  payload
) {
  const response = await axiosInstance.post(
   `/auth/session-login`,
    payload,
  );
  return response.data ?? null;
}

/**
 * Get user project permissions.
 * @param payload - {user: string | null, projectId: string | null}
 * @returns 
 */
export async function apiGetUserProjectPermission(
  payload
){
  const response = await axiosInstance.post(
   `/auth/permissions/check`,
    payload,
  );
  return response.data ?? null;
}